<div class="odx-bar-parent h-100" odxLayout="flex">
  <app-configuration-wizard-back-button
    #backButton
    [project]="project"
    [floorplanGroup]="FloorplanMenuType.MONITORING_PATIENT_MONITOR"
  >
  </app-configuration-wizard-back-button>
  <odx-wizard #configurationWizard [vertical]="true" (activeStepChanged)="setActiveStep($event)">
    <odx-wizard-step i18n="@@patientMonitorConfiguration.wizard.step1">Product Family</odx-wizard-step>
    @if (hasFamilyVariantStep) {
      <odx-wizard-step i18n="@@patientMonitorConfiguration.wizard.variant">Variant</odx-wizard-step>
    }
    @if (hasSensorStep) {
      <odx-wizard-step i18n="@@patientMonitorConfiguration.wizard.step2">Sensor</odx-wizard-step>
    }
    @if (hasMountingGroupStep) {
      <odx-wizard-step i18n="@@patientMonitorConfiguration.wizard.step3">Mounting Group</odx-wizard-step>
    }
    @if (hasMountingArmStep && needsMountingArm) {
      <odx-wizard-step i18n="@@patientMonitorConfiguration.wizard.step4">Mounting Arm</odx-wizard-step>
    }

    <odx-wizard-step i18n="@@patientMonitorConfiguration.wizard.step5">Summary</odx-wizard-step>
  </odx-wizard>

  <app-product-family-selector
    class="w-100"
    [hidden]="activeStep !== 0"
    [title]="PatientMonitorSelectorTitleKeyMap[PatientMonitorSelectorType.FAMILY]"
    [originalFamily]="originalConfiguration ?? MonitoringCategory.PATIENT_MONITORS"
    [category]="MonitoringCategory.PATIENT_MONITORS"
    [categoryLabel]="overviewCategoryLabelMap[PatientMonitorSelectorType.FAMILY]"
    (familySelect$)="setSelectedFamily($event)"
    (formReady)="selectedFamilyForm = $event"
  ></app-product-family-selector>

  @if (family; as currentFamily) {
    @if (hasFamilyVariantStep) {
      <app-option-selector
        class="w-100"
        [hidden]="activeStep !== familyVariantStepIndex"
        [selectedFamily]="currentFamily"
        [originalOptions]="originalFamilyVariantOptions"
        [title]="PatientMonitorSelectorTitleKeyMap[PatientMonitorSelectorType.VARIANT]"
        [step]="familyVariantStep"
        [category]="MonitoringCategory.PATIENT_MONITORS"
        [categoryLabel]="overviewCategoryLabelMap[PatientMonitorSelectorType.FAMILY]"
        (optionsSelect$)="setSelectedFamilyVariant($event)"
        (formReady)="selectedFamilyVariantForm = $event"
      ></app-option-selector>
    }

    @if (hasSensorStep) {
      <app-option-selector
        class="w-100"
        [hidden]="activeStep !== sensorStepIndex"
        [selectedFamily]="currentFamily"
        [originalOptions]="originalSensorOptions"
        [title]="PatientMonitorSelectorTitleKeyMap[PatientMonitorSelectorType.SENSOR]"
        [step]="sensorStep"
        [category]="MonitoringCategory.PATIENT_MONITORS"
        [categoryLabel]="overviewCategoryLabelMap[PatientMonitorSelectorType.SENSOR]"
        (optionsSelect$)="setSelectedSensor($event)"
        (formReady)="selectedSensorForm = $event"
      ></app-option-selector>
    }

    @if (hasMountingGroupStep) {
      <app-option-selector
        class="w-100"
        [hidden]="activeStep !== mountingGroupStepIndex"
        [title]="PatientMonitorSelectorTitleKeyMap[PatientMonitorSelectorType.MOUNTING_GROUP]"
        [selectedFamily]="currentFamily"
        [originalOptions]="originalMountingGroupOptions"
        [step]="mountingGroupStep"
        [category]="MonitoringCategory.PATIENT_MONITORS"
        [categoryLabel]="overviewCategoryLabelMap[PatientMonitorSelectorType.MOUNTING_GROUP]"
        (optionsSelect$)="setSelectedMountingGroup($event)"
        (formReady)="selectedMountingGroupForm = $event"
      >
      </app-option-selector>

      @if (selectedMountingGroup && needsMountingArm && hasMountingArmStep) {
        <app-option-selector
          class="w-100"
          [hidden]="activeStep !== mountingArmStepIndex && needsMountingArm"
          [title]="PatientMonitorSelectorTitleKeyMap[PatientMonitorSelectorType.MOUNTING_ARM]"
          [selectedFamily]="currentFamily"
          [originalOptions]="originalMountingArmOptions"
          [step]="mountingArmStep"
          [category]="MonitoringCategory.PATIENT_MONITORS"
          [categoryLabel]="overviewCategoryLabelMap[PatientMonitorSelectorType.MOUNTING_ARM]"
          (optionsSelect$)="setSelectedMountingArm($event)"
          (formReady)="selectedMountingArmForm = $event"
        >
        </app-option-selector>
      }
    }

    <app-monitoring-overview
      [hidden]="activeStep !== summaryStepIndex"
      [title]="PatientMonitorSelectorTitleKeyMap[PatientMonitorSelectorType.OVERVIEW]"
      [sections]="groupedSections"
      [showCategory]="true"
    ></app-monitoring-overview>
  }

  <app-product-config-stepper-bar
    (dismiss)="backButton.navigateBack()"
    (next)="onSubmit()"
    (previous)="onPrevious()"
    [activeStep]="visibleActiveStep"
    [steps]="visibleStepCount"
  >
  </app-product-config-stepper-bar>
</div>
